import { componentLoader } from '@utils/componentLoader';

const Footer = componentLoader('Footer');

const LayoutFooter = () => <Footer />;

export default LayoutFooter;
